import { render, staticRenderFns } from "./AlertBox.vue?vue&type=template&id=40a3b8be&"
import script from "./AlertBox.vue?vue&type=script&lang=ts&"
export * from "./AlertBox.vue?vue&type=script&lang=ts&"
import style0 from "./AlertBox.vue?vue&type=style&index=0&id=40a3b8be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports